import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _partition from 'lodash/partition';
import _head from 'lodash/head';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import ACTION_TYPES from '../constants/note.actionTypes';
var isPinAction = function isPinAction() {
  var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  return action.key === ACTION_TYPES.PIN;
};
export var getPinActionAndMenuActions = function getPinActionAndMenuActions(actions) {
  var _partition2 = _partition(actions, isPinAction),
    _partition3 = _slicedToArray(_partition2, 2),
    pinActions = _partition3[0],
    menuActions = _partition3[1];
  var pinAction = _head(pinActions);
  return {
    pinAction: pinAction,
    menuActions: menuActions
  };
};